import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { UIRouterModule } from '@uirouter/angular';
import { SharedModule } from '../shared/shared.module';
import { LeaveAdjustmentFeatureComponent } from './feature/leave-adjustment-feature.component';
import { LeaveAdjustmentRoute } from './LeaveAdjustmentRoute';
import { LeaveAdjustmentPresenterComponent } from './presenter/leave-adjustment-presenter.component';
import { CurrentLeaveSummaryEffects } from './store/current-leave-summary.effects';
import * as fromCurrentLeaveSummary from './store/current-leave-summary.reducer';
import { LeaveAdjustmentEffects } from './store/leave-adjustment.effects';
import * as fromLeaveAdjustment from './store/leave-adjustment.reducer';

@NgModule({
    declarations: [
        LeaveAdjustmentFeatureComponent,
        LeaveAdjustmentPresenterComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        UIRouterModule,
        UIRouterModule.forChild({
            states: [LeaveAdjustmentRoute]
        }),
        StoreModule.forFeature(
            fromLeaveAdjustment.leaveAdjustmentsFeatureKey,
            fromLeaveAdjustment.reducer
        ),
        StoreModule.forFeature(
            fromCurrentLeaveSummary.currentLeaveSummariesFeatureKey,
            fromCurrentLeaveSummary.reducer
        ),
        EffectsModule.forFeature([
            LeaveAdjustmentEffects,
            CurrentLeaveSummaryEffects
        ])
    ]
})
export class LeaveAdjustmentModule {}
